import React from 'react'
import "./style.scss"
const Icons = React.lazy(() => import('../Icons'));

const Dropdown = (props) => {

  return (
    <div className={`drop-div ${props.dropClass} ${props?.dropClass==="drop4" && (props?.drop && props?.dropC===props?.userDetails?.email) && "drop-visible"}
    ${props?.dropClass==="drop6" && (props?.drop) && "drop-visible"}`}>
    {props?.dropList?.map((ele)=> {
        const disabled = ele === "Download as .XLS" || ele === "Download as .JSON"
        return <div className={`dropdown ${props?.dropVal===ele && "dropAct"} ${(props?.dropClass==="drop4"||props?.dropClass==="drop6") && "dropdown46"} ${disabled && "dropdown-disabled"}`} onClick={()=>{if(!disabled)props?.dropFunc(ele)}}>
          {(props?.dropClass==="drop4"||props?.dropClass==="drop6") && 
          <span className='check'>
            <Icons     
                name= "check"
                width= {props?.dropClass==="drop6"?"1.042vw":"20"}
                height= {props?.dropClass==="drop6"?"1.852vh":"20"}
                fill= "#fff"
              />
          </span>}
          {ele+(props?.dropClass==="drop8"?"/Page":"")}</div>
    })
    }
    </div>
  )
}

export default Dropdown